import { GzDashboardSmartViewsListWebComponent } from './component/GzDashboardSmartViewsListWebComponent';

export { GzDashboardSmartViewsListWebComponent };
